// extracted by mini-css-extract-plugin
module.exports = {"purple":"#51378e","orangeLight":"#f1c19c","orangeHover":"#f1dfd0","orange":"#df8d46","grey":"#b0b0b0"};